import { createIconComponent } from '../../factory/create-icon-component';
export const PaperclipIcon = createIconComponent(
  'PaperclipIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 5V14.5C20 18.6421 16.6421 22 12.5 22C8.35786 22 5 18.6421 5 14.5V12.5V12L5 8V7.5V7C5 4.23858 7.23858 2 10 2C12.7614 2 15 4.23858 15 7V14.5C15 15.8807 13.8807 17 12.5 17C11.1193 17 10 15.8807 10 14.5V7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
